import React, { Suspense } from "react";

const DevButtons =
  process.env.NODE_ENV === "production"
    ? null
    : React.lazy(() => import("./Buttons"));

const DevNav: React.FC =
  process.env.NODE_ENV === "production"
    ? () => null
    : () => {
        if (typeof window === "undefined" || !DevButtons) return null;
        return (
          <Suspense fallback={null}>
            <DevButtons />
          </Suspense>
        );
      };

export default DevNav;
